import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { QrMenaMenuItem } from '@shared/service-proxies/service-proxies';
import { InvoiceDtlItem } from 'QrMena/models/qrmena-invoice-model';
@Component({
    selector: 'app-item-component',
    templateUrl: './item.component.html',
    styleUrls:['./item.component.css']
})
export class ItemComponent extends AppComponentBase{
    @Input() item:QrMenaMenuItem
    @Output() addInvoiceItemHandeler:EventEmitter<InvoiceDtlItem>=new EventEmitter<InvoiceDtlItem>()
    constructor(injector: Injector,)
    {
        super(injector);
    }

    handelAddItemToCart()
    {
        // genereate invoice item
        let invoiceItem:InvoiceDtlItem=new InvoiceDtlItem()
        invoiceItem.name=this.item.name
        invoiceItem.priceIncludeVat=this.item.price
        invoiceItem.imgUrl=this.item.imageUrl
        invoiceItem.productId=this.item.menuItemId
        let vat:number=Number((this.item.price/15).toFixed(2));
        invoiceItem.vat=vat
        invoiceItem.vatBeforeDiscount=vat
        invoiceItem.price=Number((this.item.price-vat).toFixed(2))
        invoiceItem.quantity=1
        this.addInvoiceItemHandeler.emit(invoiceItem)
        

    }
}


// WEBPACK FOOTER //
// ./src/QrMena/components/item-component/item.component.ts